import { render, staticRenderFns } from "./yizhu-edit.vue?vue&type=template&id=3f3918c5&scoped=true&"
import script from "./yizhu-edit.vue?vue&type=script&lang=ts&"
export * from "./yizhu-edit.vue?vue&type=script&lang=ts&"
import style0 from "./yizhu-edit.vue?vue&type=style&index=0&id=3f3918c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3918c5",
  null
  
)

export default component.exports